import React, { useEffect, useRef, useState } from 'react';
import './About.css';

const About = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  return (
    <section className={`about section ${isVisible ? 'visible' : ''}`} id="about" ref={sectionRef}>
      <div className="container">
        <h2 className="section-title">Welcome To Lead Talent Sourcing Solutions (LTSS)</h2>
        
        <div className="about-content">
          <p className="about-text delay-1">
            At <strong>LTSS (Lead Talent Sourcing Solutions)</strong>, we specialize in delivering high-quality candidate sourcing, lead generation (B2B & B2C), recruitment support, and virtual assistance services to businesses across the globe. With a proven track record spanning over <strong>6+ years</strong>, we have empowered companies in the <strong>UK, USA, Canada, Europe, and Australia</strong> to streamline operations, scale efficiently, and achieve measurable growth.
          </p>
          
          <p className="about-text delay-2">
            Our mission is simple: to provide businesses with the resources they need to focus on what matters most—growing their core operations. Whether you're looking to expand your sales pipeline, hire top-tier talent, or streamline day-to-day tasks, LTSS is your trusted partner every step of the way.
          </p>
          
          <div className="about-highlights">
            <div className="highlight-item delay-3">
              <h3>Our Vision</h3>
              <p>To be the global leader in talent and lead sourcing, known for innovation, reliability, and unmatched client satisfaction.</p>
            </div>
            
            <div className="highlight-item delay-4">
              <h3>Our Values</h3>
              <ul>
                <li className="value-item delay-5">
                  <span className="checkmark">✓</span>
                  <div>
                    <strong>Integrity:</strong> We operate with transparency and honesty in every interaction.
                  </div>
                </li>
                <li className="value-item delay-6">
                  <span className="checkmark">✓</span>
                  <div>
                    <strong>Excellence:</strong> We deliver results that exceed expectations.
                  </div>
                </li>
                <li className="value-item delay-7">
                  <span className="checkmark">✓</span>
                  <div>
                    <strong>Collaboration:</strong> We work closely with clients to understand their unique needs.
                  </div>
                </li>
                <li className="value-item delay-8">
                  <span className="checkmark">✓</span>
                  <div>
                    <strong>Innovation:</strong> We leverage the latest tools and strategies to stay ahead.
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;